














































































































import { defineComponent, computed } from '@nuxtjs/composition-api'
import uniqueid from 'lodash.uniqueid'

export default defineComponent({
  name: 'BlocksSliderBannerText',

  inheritAttrs: false,

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  setup(props) {
    const uid = uniqueid('uid-')
    console.log(props.data?.Banners,"props.data?.Banners")
    const banners = computed(() =>
      props.data?.Banners?.map((banner: any) => ({
        id: banner.ID,
        imageUrl: banner.ImageUrl,
        alternateUrl: banner.AlternateUrl,
        title: decodeURI(banner.Heading || banner.Title),
        text: decodeURI(banner.Text || ""),
        summary: decodeURI(banner.Summary || ""),
        // linkTitle: decodeURI(banner.LinkTitle || "")
      }))
    )

    const swiperOptions = computed(() => {
      return {
        speed: 1500,
        autoplay: {
          delay: 5000,
        },
        navigation: {
          nextEl: `.swiper-${uid} .gw-swiper-button-next`,
          prevEl: `.swiper-${uid} .gw-swiper-button-prev`,
        },
        lazy: {
          loadPrevNext: true,
        },
        loop: true,
        effect: 'fade',
        pagination: {
          el: `.swiper-${uid} .swiper-pagination`,
          clickable: true,
          crossFade: true,
        },
      }
    })

    return {
      uid,
      swiperOptions,
      banners,
    }
  },
})
